export type Env = "local" | "dev" | "qa" | "prod" | "pp";

